import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import {
  Formik, Form, FieldArray,
} from 'formik';
import {
  Input, Label, Row, Col, Button,
} from 'reactstrap';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import toastr from 'toastr';
import SweetAlert from 'react-bootstrap-sweetalert';

import Content from '../components/layout/Content';
import SnipperButton from '../components/buttons/SpinnerButton';
import {
  getLang, getDefaultLang, updateLang, newLang, deleteLang,
} from '../api/langs';

const StyledLabel = styled(Label)`
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
`;
const StyledFlagLabel = styled(Label)`
  cursor: 'pointer';
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
`;

class LanguageDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      isNewLang: false,
      languages: [],
      langName: '',
      yesOrNoAlert: false,
      langList: [],
      sweetAlert: false,
    };
  }

  async componentDidMount() {
    const { match: { params: { language } }, user, intl } = this.props;
    const masterUser = user && (user.masterUserId || user.id);

    const newLangText = intl.formatMessage({ id: 'languages.new' });

    if (language === 'new') {
      this.setState({ langName: newLangText, isNewLang: true });

      const langsResponse = await getLang(masterUser, 'new');

      const langs = [];
      langs.push({ field: 'langCodeText', value: '' });

      if (langsResponse.data.langs) {
        await Object.keys(langsResponse.data.langs).forEach((lang) => {
          langs.push({ field: lang, value: '' });
        });
        this.setState({ languages: langs });
      }

      this.setState({
        langList: [
          { code: 'ar', name: 'Arabic' },
          { code: 'az', name: 'Azerbaycan' },
          { code: 'de', name: 'Deutsch' },
          { code: 'el', name: 'Greek' },
          { code: 'es', name: 'Español' },
          { code: 'es-AR', name: 'Español (AR)' },
          { code: 'es-BO', name: 'Español (BO)' },
          { code: 'es-MX', name: 'Español (MX)' },
          { code: 'fa', name: 'Farsi' },
          { code: 'fr', name: 'Français' },
          { code: 'he', name: 'Hebrew' },
          { code: 'hu', name: 'Magyar' },
          { code: 'id', name: 'Indonesian' },
          { code: 'it', name: 'Italiano' },
          { code: 'lo', name: 'Lao' },
          { code: 'nl', name: 'Nederland' },
          { code: 'pt-BR', name: 'Portugues (Brazil)' },
          { code: 'ro', name: 'Romanian' },
          { code: 'ru', name: 'Russian' },
          { code: 'sq', name: 'Shqiperi' },
          { code: 'th', name: 'Thai' },
          { code: 'tr', name: 'Türkçe' },
          { code: 'uk', name: 'English (UK)' },
          { code: 'us', name: 'English (US)' },
          { code: 'zh', name: 'Traditional Chinese' },
          { code: 'vi', name: 'Vietnamese' },
          { code: 'tl', name: 'Tagalog' },
        ],
      });
    } else {
      const langsResponse = await getLang(masterUser, language);

      const langs = [];

      if (language === 'ar') this.setState({ langName: 'Arabic' });
      else if (language === 'az') this.setState({ langName: 'Azerbaycan' });
      else if (language === 'de') this.setState({ langName: 'Deutsch' });
      else if (language === 'el') this.setState({ langName: 'Greek' });
      else if (language === 'es') this.setState({ langName: 'Español' });
      else if (language === 'es-AR') this.setState({ langName: 'Español (AR)' });
      else if (language === 'es-BO') this.setState({ langName: 'Español (BO)' });
      else if (language === 'es-MX') this.setState({ langName: 'Español (MX)' });
      else if (language === 'fa') this.setState({ langName: 'Farsi' });
      else if (language === 'fr') this.setState({ langName: 'Français' });
      else if (language === 'he') this.setState({ langName: 'Hebrew' });
      else if (language === 'hu') this.setState({ langName: 'Magyar' });
      else if (language === 'id') this.setState({ langName: 'Indonesian' });
      else if (language === 'it') this.setState({ langName: 'Italiano' });
      else if (language === 'lo') this.setState({ langName: 'Lao' });
      else if (language === 'nl') this.setState({ langName: 'Nederland' });
      else if (language === 'pt-BR') this.setState({ langName: 'Portugues (Brazil)' });
      else if (language === 'ro') this.setState({ langName: 'Romanian' });
      else if (language === 'ru') this.setState({ langName: 'Russian' });
      else if (language === 'sq') this.setState({ langName: 'Shqiperi' });
      else if (language === 'th') this.setState({ langName: 'Thai' });
      else if (language === 'tr') this.setState({ langName: 'Türkçe' });
      else if (language === 'uk') this.setState({ langName: 'English (UK)' });
      else if (language === 'us') this.setState({ langName: 'English (US)' });
      else if (language === 'zh') this.setState({ langName: 'Traditional Chinese' });
      else if (language === 'vi') this.setState({ langName: 'Vietnamese' });
      else if (language === 'tl') this.setState({ langName: 'Tagalog' });
      else this.setState({ langName: 'UNDEFINED LANGUAGE' });

      if (langsResponse.data.langs) {
        await Object.keys(langsResponse.data.langs).forEach((lang) => {
          langs.push({ field: lang, value: langsResponse.data.langs[lang] });
        });
        this.setState({ languages: langs });
      }
    }
  }

  deleteLanguage = async () => {
    this.setState({ sweetAlert: false });
    const {
      match: { params: { language } }, user, history, intl,
    } = this.props;
    const deletedText = intl.formatMessage({ id: 'lang.delete.success' });
    const errorText = intl.formatMessage({ id: 'error' });
    const masterUser = user && (user.masterUserId || user.id);
    await deleteLang(masterUser, language).then((result) => {
      toastr.success(deletedText);
      this.timeout = setTimeout(() => {
        history.goBack();
      }, 1000);
    }, (error) => {
      toastr.error(errorText);
    });
  }

  render() {
    const { match: { params: { language: langNamed } }, intl, user } = this.props;
    const {
      languages, langName, isNewLang, loading, sweetAlert,
    } = this.state;

    const langs = {};
    langs.langCodeText = intl.formatMessage({ id: 'languages.code' });
    langs.homeText = intl.formatMessage({ id: 'sidebar.menu.home' });
    langs.languagesText = intl.formatMessage({ id: 'sidebar.menu.languages' });
    langs.savedText = intl.formatMessage({ id: 'saved' });
    langs.currency = intl.formatMessage({ id: 'language.currency' });
    langs.alertConfirmButton = intl.formatMessage({ id: 'language.alertConfirmButton' });
    langs.alertCancelButton = intl.formatMessage({ id: 'language.alertCancelButton' });
    langs.tabletUpdateTitle = intl.formatMessage({ id: 'language.tabletUpdateTitle' });
    langs.tabletUpdateSubstitle = intl.formatMessage({ id: 'language.tabletUpdateSubstitle' });
    langs.itemPiece = intl.formatMessage({ id: 'language.itemPiece' });
    langs.headerCallWaiterTitle = intl.formatMessage({ id: 'language.headerCallWaiterTitle' });
    langs.headerCallWaiterSubstitle = intl.formatMessage({ id: 'language.headerCallWaiterSubstitle' });
    langs.headerMyOrdersText = intl.formatMessage({ id: 'language.headerMyOrdersText' });
    langs.headerCallingWaiterSuccessTitle = intl.formatMessage({ id: 'language.headerCallingWaiterSuccessTitle' });
    langs.headerCallingWaiterSuccessSubstitle = intl.formatMessage({ id: 'language.headerCallingWaiterSuccessSubstitle' });
    langs.headerCallingWaiterFailedTitle = intl.formatMessage({ id: 'language.headerCallingWaiterFailedTitle' });
    langs.headerCallingWaiterFailedSubstitle = intl.formatMessage({ id: 'language.headerCallingWaiterFailedSubstitle' });
    langs.headerWaiterText = intl.formatMessage({ id: 'language.headerWaiterText' });
    langs.passwordMenuText = intl.formatMessage({ id: 'language.passwordMenuText' });
    langs.passwordAlertTitle = intl.formatMessage({ id: 'language.passwordAlertTitle' });
    langs.passwordAlertSubstitle = intl.formatMessage({ id: 'language.passwordAlertSubstitle' });
    langs.passwordWrongPinText = intl.formatMessage({ id: 'language.passwordWrongPinText' });
    langs.basketSelectPortion = intl.formatMessage({ id: 'language.basketSelectPortion' });
    langs.basketSelectTag = intl.formatMessage({ id: 'language.basketSelectTag' });
    langs.basketButtonText = intl.formatMessage({ id: 'language.basketButtonText' });
    langs.basketChangeButtonText = intl.formatMessage({ id: 'language.basketChangeButtonText' });
    langs.errorNetworkTitle = intl.formatMessage({ id: 'language.errorNetworkTitle' });
    langs.errorNetworkSubstitle = intl.formatMessage({ id: 'language.errorNetworkSubstitle' });
    langs.errorEmptyListTitle = intl.formatMessage({ id: 'language.errorEmptyListTitle' });
    langs.errorEmptyListSubstitle = intl.formatMessage({ id: 'language.errorEmptyListSubstitle' });
    langs.errorOrderFailedTitle = intl.formatMessage({ id: 'language.errorOrderFailedTitle' });
    langs.errorOrderFailedSubstitle = intl.formatMessage({ id: 'language.errorOrderFailedSubstitle' });
    langs.errorEntityFailedTitle = intl.formatMessage({ id: 'language.errorEntityFailedTitle' });
    langs.errorEntityFailedSubstitle = intl.formatMessage({ id: 'language.errorEntityFailedSubstitle' });
    langs.orderSuccessTitle = intl.formatMessage({ id: 'language.orderSuccessTitle' });
    langs.orderSuccessSubstitle = intl.formatMessage({ id: 'language.orderSuccessSubstitle' });
    langs.orderValidateTitle = intl.formatMessage({ id: 'language.orderValidateTitle' });
    langs.orderValidateSubstitle = intl.formatMessage({ id: 'language.orderValidateSubstitle' });
    langs.orderListTitle = intl.formatMessage({ id: 'language.orderListTitle' });
    langs.orderListSubstitle = intl.formatMessage({ id: 'language.orderListSubstitle' });
    langs.orderEmptyList = intl.formatMessage({ id: 'language.orderEmptyList' });
    langs.orderButtonTitle = intl.formatMessage({ id: 'language.orderButtonTitle' });
    langs.orderSendingTitle = intl.formatMessage({ id: 'language.orderSendingTitle' });
    langs.orderSendingSubstitle = intl.formatMessage({ id: 'language.orderSendingSubstitle' });
    langs.homeEntityDialogTitle = intl.formatMessage({ id: 'language.homeEntityDialogTitle' });
    langs.homeEntityDialogSubstitle = intl.formatMessage({ id: 'language.homeEntityDialogSubstitle' });
    langs.homeQrButtonOpenTitle = intl.formatMessage({ id: 'language.homeQrButtonOpenTitle' });
    langs.homeQrButtonCloseTitle = intl.formatMessage({ id: 'language.homeQrButtonCloseTitle' });
    langs.homeEntityTitle = intl.formatMessage({ id: 'language.homeEntityTitle' });
    langs.homeSettingsTitle = intl.formatMessage({ id: 'language.homeSettingsTitle' });
    langs.homeConnectedEntityTitle = intl.formatMessage({ id: 'language.homeConnectedEntityTitle' });
    langs.homeConnectedEntitySubstitle = intl.formatMessage({ id: 'language.homeConnectedEntitySubstitle' });
    langs.homeNoConnectedEntityTitle = intl.formatMessage({ id: 'language.homeNoConnectedEntityTitle' });
    langs.homeUpdateButton = intl.formatMessage({ id: 'language.homeUpdateButton' });
    langs.homeMenuButton = intl.formatMessage({ id: 'language.homeMenuButton' });
    langs.homeSettingsButton = intl.formatMessage({ id: 'language.homeSettingsButton' });
    langs.productBackButtonTitle = intl.formatMessage({ id: 'language.productBackButtonTitle' });
    langs.splashCriticalErrorTitle = intl.formatMessage({ id: 'language.splashCriticalErrorTitle' });
    langs.splashCriticalErrorSubstitle = intl.formatMessage({ id: 'language.splashCriticalErrorSubstitle' });
    langs.settingsErrorNetworkTitle = intl.formatMessage({ id: 'language.settingsErrorNetworkTitle' });
    langs.settingsErrorNetworkSubstitle = intl.formatMessage({ id: 'language.settingsErrorNetworkSubstitle' });
    langs.settingsErrorUncaughtTitle = intl.formatMessage({ id: 'language.settingsErrorUncaughtTitle' });
    langs.settingsErrorUncaughtSubstitle = intl.formatMessage({ id: 'language.settingsErrorUncaughtSubstitle' });
    langs.settingsErrorCode = intl.formatMessage({ id: 'language.settingsErrorCode' });
    langs.settingsIncorrect = intl.formatMessage({ id: 'language.settingsIncorrect' });
    langs.settingsSuccessTitle = intl.formatMessage({ id: 'language.settingsSuccessTitle' });
    langs.settingsSuccessSubstitle = intl.formatMessage({ id: 'language.settingsSuccessSubstitle' });
    langs.settingsWaitingAuthTitle = intl.formatMessage({ id: 'language.settingsWaitingAuthTitle' });
    langs.settingsWaitingAuthSubstitle = intl.formatMessage({ id: 'language.settingsWaitingAuthSubstitle' });
    langs.settingsCheckTitle = intl.formatMessage({ id: 'language.settingsCheckTitle' });
    langs.settingsCheckSubstitle = intl.formatMessage({ id: 'language.settingsCheckSubstitle' });
    langs.settingsSaveButton = intl.formatMessage({ id: 'language.settingsSaveButton' });
    langs.settingsGoButton = intl.formatMessage({ id: 'language.settingsGoButton' });

    const confirmText = intl.formatMessage({ id: 'confirm' });
    const areYouSureText = intl.formatMessage({ id: 'areyousure' });
    const cancelText = intl.formatMessage({ id: 'cancel' });
    const saveText = intl.formatMessage({ id: 'save' });

    const deleteLangText = intl.formatMessage({ id: 'lang.delete' });

    return (
      <Content language={!isNewLang} onClick={() => this.setState({ sweetAlert: true })} title={langs.languagesText} breads={[{ to: '/panel', name: langs.homeText }, { to: '/panel/languages', name: langs.languagesText }, { name: langName }]} text={deleteLangText}>

        {languages && languages.length > 0
          && (
            <Formik
              enableReinitialize
              initialValues={{ lang: languages }}
              onSubmit={async (values) => {
                this.setState({ loading: true });
                const masterUser = user && (user.masterUserId || user.id);
                if (isNewLang) {
                  await newLang(masterUser, values.lang[0].value, values);
                } else {
                  await updateLang(masterUser, langNamed, values);
                }
                this.setState({ loading: false });
                toastr.success('', langs.savedText);
              }}
              render={({ values, handleChange, setFieldValue }) => (
                <Form>
                  <FieldArray
                    name="translations"
                    render={() => (
                      <div>
                        {values.lang.map((translate, index) => (
                          <Row key={index} style={{ margin: '10px' }}>
                            <Col sm={3}>
                              <StyledLabel for={`lang[${index}].field`}>{langs[translate.field]}</StyledLabel>
                            </Col>
                            <Col sm={(isNewLang && index === 0 ? 1 : 9)}>
                              <Input
                                type="text"
                                name={`lang.${index}.value`}
                                id={`lang.${index}.value`}
                                onChange={(e) => {
                                  handleChange(e);
                                }}
                                value={translate.value}
                                disabled={(!!(isNewLang && index === 0))}
                                autoFocus={translate.field === 'submit'}
                              />
                            </Col>
                            {isNewLang && index === 0 && (
                              <Col sm={8}>
                                <FieldArray
                                  name="flags"
                                  render={() => (
                                    <div>
                                      <Row>
                                        {this.state.langList.map((lang) => (
                                          <Col sm={1} key={index}>
                                            <Button
                                              color="link"
                                              onClick={async () => {
                                                setFieldValue(`lang.${index}.value`, lang.code);
                                                this.setState({ selectedLang: lang.code });

                                                const langsResponse = await getDefaultLang(lang.code);

                                                const langs = [];
                                                langs.push({ field: 'langCodeText', value: lang.code });

                                                if (langsResponse.data.langs) {
                                                  await Object.keys(langsResponse.data.langs).forEach((lang) => {
                                                    langs.push({ field: lang, value: langsResponse.data.langs[lang] });
                                                  });
                                                  this.setState({ languages: langs });
                                                }
                                                handleChange();
                                              }}
                                              style={{ cursor: 'pointer', padding: 0 }}
                                            >
                                              <StyledFlagLabel isSelected={this.state.selectedLang === lang.code}><img src={`/images/flags/${lang.code}.png`} alt="" style={{ cursor: 'pointer' }} /></StyledFlagLabel>
                                            </Button>
                                          </Col>
                                        ))}
                                      </Row>
                                    </div>
                                  )}
                                />
                              </Col>
                            )}
                          </Row>
                        ))}
                        <Row>
                          <Col sm={12}>
                            <SnipperButton type="submit" loading={loading} text={saveText} />
                          </Col>
                        </Row>
                      </div>
                    )}
                  />
                </Form>
              )}
            />
          )}
        <SweetAlert
          show={sweetAlert}
          warning
          showCancel
          cancelBtnText={cancelText}
          confirmBtnText={confirmText}
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          title={areYouSureText}
          onConfirm={this.deleteLanguage}
          onCancel={() => this.setState({ sweetAlert: false })}
        />
      </Content>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  user: state.auth.user,
});

LanguageDetail.defaultProps = {
  match: {
    params: {
      language: 'uk',
    },
  },
};

LanguageDetail.propTypes = {
  intl: intlShape.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      language: PropTypes.string.isRequired,
    }),
  }),
  user: PropTypes.shape({
    isAdmin: PropTypes.number,
    id: PropTypes.number,
    masterUserId: PropTypes.oneOf([PropTypes.number, null]),
  }).isRequired,
};

export default injectIntl(connect(mapStateToProps)(LanguageDetail));
